import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import axios from "axios";
import moment from "moment";
import { queryParams } from "../../../utils/queryParams";
import { getIds } from "../../../utils/getIds";

export const SET_LOADING = "./BrandLeaderBoard/SET_LOADING";
export const FETCH_CURRENT_USER = "./BrandLeaderBoard/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "./BrandLeaderBoard/FETCH_CURRENT_USER_SUCCESS";
export const RESET_FILTER_SELECTED = "./BrandLeaderBoard/RESET_FILTER_SELECTED";
export const SET_DATES = "./BrandLeaderBoard/SET_DATES";
export const UPDATE_DATES = "./BrandLeaderBoard/UPDATE_DATES";
export const RESET_FILTER = "./BrandLeaderBoard/RESET_FILTERS";
export const UPDATE_VIEW_FILTER = "./BrandLeaderBoard/UPDATE_VIEW_FILTER";
export const UPDATE_TABLE_DATA = "./BrandLeaderBoard/UPDATE_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "./BrandLeaderBoard/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "./BrandLeaderBoard/FETCH_FILTERS_SUCCESS";
export const SET_SELECTED_METRICS = "./BrandLeaderBoard/SET_SELECTED_METRICS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateView: createAction(UPDATE_VIEW_FILTER),
  updateTableData: createAction(UPDATE_TABLE_DATA),
  updateDates: createAction(UPDATE_DATES),
  resetFilters: createAction(RESET_FILTER),
  updateSelectedMetricsFilter: createAction(SET_SELECTED_METRICS)
};

export default function* watchActiveMembers() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_TABLE_DATA, fetchTableData);
  yield takeLatest(RESET_FILTER, resetFilters);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  let dates = yield getDatesHelper();
  yield setDates(...dates);
  try {
    yield getFilters();
    yield fetchTableData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getCommonApiParams() {
  return yield select((state) => {
    const {
      currentUser: { organizationId, locationId, objectId, regionId },
      selectedRequestDates: { startDate, endDate },
      selectedMetrics
    } = state.BrandLeaderBoard;

    if (!organizationId && !locationId && !objectId && !regionId && !startDate && !endDate) return;
    return {
      organization_id: organizationId,
      location_id: locationId,
      object_id: objectId,
      region_id: regionId,
      startDate,
      endDate,
      metrics: getIds(selectedMetrics)
    };
  });
}

export function* fetchTableData() {
  yield put({ type: SET_LOADING, payload: true });

  const { organization_id, location_id, object_id, region_id, startDate, endDate, metrics } =
    yield getCommonApiParams();
  const { selectedViewOption } = yield select((state) => state.BrandLeaderBoard);
  const params = {
    organization_id,
    location_id,
    object_id,
    region_id,
    end_date: endDate,
    start_date: startDate,
    view_type: selectedViewOption.name.toLowerCase(),
    metrics
  };

  let url = queryParams.apiVersion + "/pages/brand_leaderboard/brand_leaderboard_page";

  try {
    let { data } = yield call(axios.get, url, { params });

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: data });
    yield put({ type: SET_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}

export function* setDates(startDate, endDate) {
  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

export function* getFilters() {
  const { organization_id } = yield getCommonApiParams();
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "/pages/brand_leaderboard/brand_leaderboard_page/get_filters" +
        "?organization_id=" +
        organization_id
    );

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  let dates = yield getDatesHelper();
  yield setDates(...dates);
  yield put({ type: RESET_FILTER_SELECTED });
  try {
    yield getFilters();
    yield fetchTableData();
  } catch (error) {
    console.error(error);
  }
}

function* getDatesHelper() {
  const endDate = yield select((state) => state.BrandLeaderBoard.currentUser.calendarEndDate);
  const startDate = moment(endDate).startOf("month").format("YYYY-MM-DD");
  return [startDate, endDate];
}
